import React from "react";
import { useSignUpTerms } from "../../features/auth/hooks/queries";
import Skeleton from "../../components/foundation/Skeleton";
import styled from "styled-components";

type PolicyProps = {
  policyName: string;
  policyType: "TERMS_OF_SERVICE" | "PRIVACY_POLICY";
};

export const Policy = (props: PolicyProps) => {
  const { data: policyData } = useSignUpTerms({
    policyType: props.policyType,
  });

  return (
    <PolicyStyle>
      <h1>{props.policyName}</h1>
      <br />
      {policyData?.policyText ?? <Skeleton type="text" />}
    </PolicyStyle>
  );
};

export const PolicyStyle = styled.div`
  h1 {
    text-align: center;
    ${({ theme }) => theme.typography.h1.bold}
  }

  ${({ theme }) => theme.typography.body1}
  margin: 2.4rem;
  white-space: pre-wrap;
`;

export default Policy;
